export const validateDistributor = (data) => {
  const errors = {};

  if (!data.distributorName?.trim()) {
    errors.distributorName = 'Distributor name is required';
  } else if (data.distributorName.length > 255) {
    errors.distributorName = 'Distributor name should be at most 255 characters';
  }

  if (!data.licenseNumber?.trim()) {
    errors.licenseNumber = 'Distributor license number is required';
  } else if (data.licenseNumber.length > 100) {
    errors.licenseNumber = 'License number should be at most 100 characters';
  }

  if (!data.status?.trim()) {
    errors.status = 'Status is required';
  } else if (!['Active', 'Inactive', 'active', 'inactive'].includes(data.status)) {
    errors.status = 'Status should be either Active or Inactive';
  }

  if (data.distributorBillingEmail) {
    if (data.distributorBillingEmail.length > 255) {
      errors.distributorBillingEmail = 'Email should be at most 255 characters';
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(data.distributorBillingEmail)) {
        errors.distributorBillingEmail = 'Please enter a valid email address';
      }
    }
  }

  if (data.phoneNumber) {
    const digitsOnly = String(data.phoneNumber).replace(/\D/g, '');
    if (digitsOnly.length !== 10) {
      errors.phoneNumber = 'Please enter a valid 10-digit phone number';
    }
  }

  const isValid = Object.keys(errors).length === 0;
  return { isValid, errors };
};

export default validateDistributor;
